import { getKeys } from './getKeys'

export const carePlansTranslations = {
  ERROR_FLUID_TARGET_CAN_NOT_BE_EMPTY: 'Fluid target can not be empty',
  ERROR_INVALID_CHARACTER: 'Invalid character',
  ERROR_FLUID_TARGET_CAN_NOT_BE_0: 'Fluid target can not be 0',
  ERROR_CORRECT_AMOUNT: 'Make sure you have typed the correct amount',
  FLUID_TRACKING: 'Fluid tracking',
  DISABLE: 'Disable',
  ENABLE: 'Enable',
  FIND_OUT_MORE: 'Find out more',
  DAILY_INTAKE_TARGET: 'Daily intake target',
  SELECT_NEEDS: 'Select Needs',
  CHOOSE_FORM_LIST: 'Choose from list',
  NO_CURRENT_TARGET: 'No current target',
  DAILY_INTAKE_TARGET_ML: 'Daily intake target of {{intakeTarget}}ml',

  //ResidentCarePlansDashboardScreen
  REVIEWED: 'Reviewed',
  CREATED: 'Created',
  NO_REVIEWS_YET: 'No reviews yet',
  CARE_PLAN: 'Care Plan',
  DOWNLOAD_PDF: 'Download PDF',
  PDF: 'PDF',
  ADD: 'Add',
  SORT_BY: 'Sort by:',
  NO_FURTHER_SUPPORT_REQUIRED: 'No Further Support Required',
  NOTHING_TO_SEE_HERE: 'Nothing to see here!',
  FINALISE_INITIAL_ASSESSMENT:
    "Finalise {{name}}'s Initial Assessment for this {{carePlanNominative}}",
  FINALISE_INITIAL_ASSESSMENT_DESCRIPTION:
    "When you finalise the Initial Assessment for this {{preferredPeopleNominative}},  you'll be able to create their {{carePlanNominative}}",
  RESIDENT: 'resident',
  BLANK_STATE_DESCRIPTION_ADLS:
    "{{carePlanNominative}} will appear here if they have been reviewed as having 'No Further Support Required'.",

  // Consent Section
  CONSENT_SECTION_TITLE: 'Consent',
  CONSENT_SECTION_DESCRIPTION: 'Link consent forms here or manage all consent forms in',
  CONSENT_SECTION_DESCRIPTION_VIEW: 'Link consent forms by reviewing this care plan, or manage all consent forms in',
  CONSENT_MANAGEMENT_LINK: 'Consent management',
  LINK_CONSENT_BUTTON: 'Link Consent',
  CONSENT_MODAL_TITLE: 'Select from available Consent forms',
  CONSENT_MODAL_PLACEHOLDER: 'Select consent form to link',
  CONSENT_MODAL_CONFIRM: 'Confirm',
  CONSENT_MODAL_CANCEL: 'Cancel',
  CONSENT_SIGNED_ON: 'Signed on {{date}} - {{createdBy}}',
  CONSENT_CREATED_ON: 'Created on {{date}} - {{createdBy}}',
  CONSENT_REFUSED: 'Refused consent',

  // Consent Form Item
  CONSENT_FORM_CREATED_DATE: 'Created on {{date}} - {{createdBy}}',
  CONSENT_FORM_SIGNED_DATE: 'Signed on {{date}} - {{signedBy}}',
  CONSENT_STATUS_COMPLETED: 'Completed',
  CONSENT_STATUS_PENDING: 'Pending',
  CONSENT_STATUS_REQUESTED: 'Requested',
  CONSENT_STATUS_REFUSED: 'Refused',
  CONSENT_STATUS_WITHDRAWN: 'Withdrawn',
  CONSENT_STATUS_PLANNED: 'Planned',
  CONSENT_STATUS_SCHEDULED: 'Scheduled',
  CONSENT_STATUS_POSTPONED: 'Postponed',
  CONSENT_STATUS_CANCELLED: 'Cancelled',
  CONSENT_STATUS_PROVIDED: 'Provided'
}

export const carePlansConstants = getKeys(carePlansTranslations)
